import { DataBean } from "../DataBean";

export class BankingAccount extends DataBean {


    public async getBankingAccountTypesConstants(): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBankingAccountTypesConstants_Number", [null]);
    }

}